import type { FileObjectType } from "@jsq/ds/core";

export type RejectedUploadFile = {
  file: File;
  error: string;
};

export const UNSUPPORTED_FILE_FORMAT_ERROR = "File format not supported";

export const getRejectedUploadFiles = (
  files: FileObjectType[],
): RejectedUploadFile[] | undefined => {
  const rejectedFile = files.find((file) => file.status === "rejected");
  if (!rejectedFile) {
    return undefined;
  }

  return [{ file: rejectedFile.file, error: UNSUPPORTED_FILE_FORMAT_ERROR }];
};

export const getAcceptedUploadFile = (files: FileObjectType[]): FileObjectType | undefined => {
  return files.find((file) => file.status === "accepted");
};
